import { AppState } from '../../common/configuration/app.states';

export const getConnectedUser = (state: AppState) => state.auth.connectedUser;

export const getTryingToSignIn = (state: AppState) => state.auth.tryingToSignIn;

// export const getAuthTokens = (state: AppState) => state.auth.authTokens;
